import { useEffect, useState, useMemo } from "react";
import { getData } from "../../../../services/library";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { v4 as uuidv4 } from "uuid";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import moment from "moment";
import {
  Box,
  Chip,
  ListItemIcon,
  MenuItem,
  Typography,
  Badge,
  Container,
} from "@mui/material";

import DetalleReclamo2 from "../instalaciones/DetalleReclamo2";
import {
  AttachFile,
  Beenhere,
  Build,
  DoDisturbAlt,
  DoneOutline,
  Edit,
  Receipt,
  ExpandMore,
} from "@mui/icons-material";
import ConfirmarGrua from "../ConfirmarGrua";
import AsignarTecnico2 from "../instalaciones/AsignarTecnico2";
import FinalizarReclamo from "../FinalizarReclamo";
import Facturado from "../Facturado";
import EditarReclamoInst from "../instalaciones/EditarReclamoInst";
import CancelarReclamo2 from "../instalaciones/CancelarReclamo2";
import UpdatedUploadFiles from "../../../../services/UpdatedUploadFiles";
import ModalPendienteDeFinalizacion from "../ModalPendienteDeFinalizacion";
import { useToast } from "../../../../Hooks/UseToast";

export default function Instalaciones2(props) {
  const { Toast, showToast } = useToast();
  const [reclamos, setReclamos] = useState();
  const [tabla, setTabla] = useState(true);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [dataReclamo, setDataReclamo] = useState({});
  const [confirmarGrua, setconfirmarGrua] = useState(false);
  let sector = localStorage.getItem("sector");
  const categoriasGrua = ["281", "321"];
  const categoriasInstalaciones = ["281", "321"];
  const estadoReclamosInstalaciones = [
    "170",
    "343",
    "344",
    "346",
    "342",
    "171",
    "347",
    "223",
  ];
  const categoriasReemplazos = ["321"];
  const estadoReclamosReemplazos = [
    "170",
    "343",
    "344",
    "342",
    "171",
    "192",
    "348",
  ];
  const [cantidadReclamos, setcantidadReclamos] = useState([]);
  const [cantidadTanques, setcantidadTanques] = useState({});
  const [haytanques, sethayTanques] = useState(false);
  const [asignar, setAsignar] = useState(false);
  const [pendienteFinalizar, setPendienteFinalizar] = useState(false);
  const [finalizar, setFinalizar] = useState(false);
  const [facturar, setFacturar] = useState(false);
  const [editar, setEditar] = useState(false);
  const [cancelar, setCancelar] = useState(false);
  const [openclose, setopenclose] = useState(false);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState(null);
  const estadosConfig = [
    { key: "abiertos", label: "Abiertos", color: "info", id: 192 },
    { key: "asignados", label: "Asignados", color: "primary", id: 170 },
    { key: "cancelados", label: "Cancelados", color: "error", id: 223 },

    {
      key: "pendiente_fin",
      label: "Pendiente finalizacion",
      color: "warning",
      id: 342,
    },
    { key: "en_transito", label: "En tránsito", color: "secondary", id: 346 },
    { key: "en_proceso", label: "En proceso", color: "warning", id: 348 },
    { key: "finalizados", label: "Finalizados", color: "success", id: 171 },
  ];

  //obtengo todos los reclamos para la tabla
  //lo unico que tengo que filtrar es por categoria y por estado
  const getReclamos = () => {
    const isSector12 = sector === "12";
    const prefix = isSector12 ? "/reclamos/all" : "/reclamos/all_comercial";
    const user = localStorage.getItem("user");

    let categorias = "";
    let estados = "";
    let url = "";

    if (props.activeTab === 0) {
      categorias = categoriasGrua.join(",");
      estados = ["275", "348"];

      url = isSector12
        ? `${prefix}/${categorias}/${estados}`
        : `${prefix}/${categorias}/${estados}/${user}`;
    }

    // 🟢 TAB 1 (ACÁ va la lógica nueva)
    else if (props.activeTab === 1) {
      if (estadoSeleccionado) {
        // 👉 si hay chip seleccionado
        url = `/reclamos/rec_tab1/${estadoSeleccionado}`;
        console.log("url", url);
      } else {
        categorias = categoriasInstalaciones.join(",");
        estados = estadoReclamosInstalaciones.join(",");

        url = isSector12
          ? `${prefix}/${categorias}/${estados}`
          : `${prefix}/${categorias}/${estados}/${user}`;

        console.log("URL", url);
      }
    }

    // 🟡 TAB 2 (queda como estaba)
    else {
      categorias = categoriasReemplazos.join(",");

      estados = estadoSeleccionado
        ? estadoSeleccionado
        : estadoReclamosReemplazos.join(",");

      url = isSector12
        ? `${prefix}/${categorias}/${estados}`
        : `${prefix}/${categorias}/${estados}/${user}`;
    }

    getData(url, setReclamos);

    // 🔹 Cantidades (esto lo dejás igual)
    if (props.activeTab === 0) {
      if (isSector12) {
        getData("/reclamos/cantTanquesGrua", setcantidadTanques);
      } else {
        getData(
          `/reclamos/comercial_cantTanquesGrua/${user}`,
          setcantidadTanques,
        );
      }
    }

    if (props.activeTab === 1) {
      if (isSector12) {
        getData(`/reclamos/allr/cantidad_reclamos/281`, setcantidadReclamos);
      } else {
        getData(
          `/reclamos/cantidadReclamosComercial/${user}/281`,
          setcantidadReclamos,
        );
      }
    }

    if (props.activeTab === 2) {
      if (isSector12) {
        getData(`/reclamos/cantidadTanqueReemplazo`, setcantidadTanques);
        getData(`/reclamos/allr/cantidad_reclamos/321`, setcantidadReclamos);
      } else {
        getData(
          `/reclamos/cantidadReclamosComercial/${user}/321`,
          setcantidadReclamos,
        );
      }
    }
  };

  useEffect(() => {
    getReclamos();
  }, [props.activeTab, tabla, estadoSeleccionado]);

  useEffect(() => {
    setEstadoSeleccionado(null);
  }, [props.activeTab]);

  const reclamosFiltrados = useMemo(() => {
    if (!estadoSeleccionado) return reclamos;
    const categoria =
      props.activeTab === 1 ? 281 : props.activeTab === 2 ? 321 : (281, 321);

    return (
      reclamos &&
      reclamos.filter(
        (r) => r.estado === estadoSeleccionado && r.categoria === categoria,
      )
    );
  }, [reclamos, estadoSeleccionado]);

  //DEFINO LAS COLUMNAS PARA LAS TABLAS
  const getColumnsGrua = () => {
    let columns = [
      {
        header: "OT",
        accessorKey: "id_reclamo",
        maxSize: 40,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Cliente",
        accessorKey: "id_cliente",
        accessorFn: (c) =>
          c.sisven_id
            ? `(${c.sisven_id}) ${c.razon_social} `
            : `${c.razon_social}`,
        size: 200,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        id: "cantidad_tanques",
        header: "Tanques instalados",
        accessorFn: (c) => {
          const list = [];

          if (c.canttk_05) list.push(...Array(c.canttk_05).fill("0.5m3"));
          if (c.canttk_1) list.push(...Array(c.canttk_1).fill("1m3"));
          if (c.canttk_2) list.push(...Array(c.canttk_2).fill("2m3"));
          if (c.canttk_4) list.push(...Array(c.canttk_4).fill("4m3"));
          if (c.canttk_7) list.push(...Array(c.canttk_7).fill("7m3"));
          if (c.canttk_otros) list.push(...Array(c.canttk_otros).fill("Otros"));

          return list.length > 0 ? list.join(", ") : "-";
        },
        size: 230,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Registrado",
        accessorKey: "created_at",
        sortingFn: "datetime",
        Cell: ({ cell }) => moment(cell.getValue()).format("DD-MM-YYYY"),
        size: 60,
        // enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Planta",
        accessorKey: "nombre_sucursal",
        accessorFn: (c) => (c.nombre_sucursal ? `${c.nombre_sucursal}` : `- `),
        size: 80,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Localidad",
        accessorKey: "localidad",
        // accesorFn: (c) => c.nombre_sucursal ? `${c.nombre_sucursal}` : `- `,
        size: 80,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
    ];
    return columns;
  };

  const columnsGrua = useMemo(() => getColumnsGrua(reclamos), [reclamos]);

  const getColumnsInstalacion = () => {
    let columnsInstalacion = [
      {
        header: "OT",
        accessorKey: "id_reclamo",
        maxSize: 50,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Cliente",
        accessorKey: "id_cliente",
        accessorFn: (c) =>
          c.sisven_id
            ? `(${c.sisven_id}) ${c.razon_social} `
            : `${c.razon_social}`,
        size: 230,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Registrado",
        accessorKey: "created_at",
        sortingFn: "datetime",
        Cell: ({ cell }) => moment(cell.getValue()).format("DD-MM-YYYY"),
        size: 60,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Prioridad",
        accessorKey: "valor_prioridad",
        size: 90,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Instalador",
        accessorKey: "razon_prov",
        size: 100,
        enableColumnFilter: true,
        filterFn: "fuzzy",
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Estado",
        accessorKey: "estado_reclamo",
        size: 80,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Facturado",
        accessorKey: "facturado",
        accessorFn: (r) => (r.facturado === 0 ? "No" : "Si"),
        size: 85,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Finalizado",
        accessorKey: "fecha_finalizado",
        sortingFn: (rowA, rowB, columnId) => {
          const a = rowA.getValue(columnId);
          const b = rowB.getValue(columnId);

          if (!a && !b) return 0;
          if (!a) return 1; // null abajo
          if (!b) return -1;

          return new Date(a) - new Date(b);
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? moment(value).format("DD-MM-YYYY") : "—";
        },
        size: 90,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "center" },
      },
      {
        header: "Planta",
        accessorKey: "nombre_sucursal",
        accessorFn: (c) => (c.nombre_sucursal ? `${c.nombre_sucursal}` : `- `),
        size: 80,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Localidad",
        accessorKey: "localidad",
        // accesorFn: (c) => c.nombre_sucursal ? `${c.nombre_sucursal}` : `- `,
        size: 80,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
    ];
    return columnsInstalacion;
  };

  const columnsIntalacion = useMemo(
    () => getColumnsInstalacion(reclamos),
    [reclamos],
  );

  const getColumnsReemplazo = () => {
    let columnsReemplazo = [
      {
        header: "OT",
        accessorKey: "id_reclamo",
        maxSize: 50,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Cliente",
        accessorKey: "id_cliente",
        accessorFn: (c) =>
          c.sisven_id
            ? `(${c.sisven_id}) ${c.razon_social} `
            : `${c.razon_social}`,
        size: 230,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Registrado",
        accessorKey: "created_at",
        sortingFn: "datetime",
        Cell: ({ cell }) => moment(cell.getValue()).format("DD-MM-YYYY"),
        size: 230,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Instalador",
        accessorKey: "razon_prov",
        size: 90,
        enableColumnFilter: true,
        filterFn: "fuzzy",
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Estado",
        accessorKey: "estado_reclamo",
        size: 70,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Planta",
        accessorKey: "nombre_sucursal",
        accessorFn: (c) => (c.nombre_sucursal ? `${c.nombre_sucursal}` : `- `),
        size: 80,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Facturado",
        accessorKey: "facturado",
        accessorFn: (r) => (r.facturado === 0 ? "No" : "Si"),
        size: 85,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
      {
        header: "Finalizado",
        accessorKey: "fecha_finalizado",
        sortingFn: (rowA, rowB, columnId) => {
          const a = rowA.getValue(columnId);
          const b = rowB.getValue(columnId);

          if (!a && !b) return 0;
          if (!a) return 1; // null abajo
          if (!b) return -1;

          return new Date(a) - new Date(b);
        },
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? moment(value).format("DD-MM-YYYY") : "—";
        },
        size: 90,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "center" },
      },
      {
        header: "Localidad",
        accessorKey: "localidad",
        // accesorFn: (c) => c.nombre_sucursal ? `${c.nombre_sucursal}` : `- `,
        size: 80,
        enableColumnFilter: true,
        muiTableBodyCellProps: { align: "left" },
      },
    ];
    return columnsReemplazo;
  };

  const columnsReemplazo = useMemo(
    () => getColumnsReemplazo(reclamos),
    [reclamos],
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "5rem", backgroundColor: "#ffffff", mt: 1 },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    // sorting: [{ id: "id_reclamo", desc: true }],
    columnPinning: { right: ["mrt-row-actions"] },
    showColumnFilters: true,
  };

  const tableHeadCellProps = {
    align: "center",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expand: <ExpandMore />,
  };

  const filteredColumns = useMemo(() => {
    switch (props.activeTab) {
      case 0:
        return columnsGrua;
      case 1:
        return columnsIntalacion;
      case 2:
        return columnsReemplazo;
      default:
        return [];
    }
  }, [props.activeTab]);

  const bgcolor = {
    169: "#ffffff",
    170: "#7cc993ff",
    171: "#C3EFD0",
    223: "#cf7754ff",
  };

  useEffect(() => {
    if (dataReclamo?.id_reclamo) {
      const actualizado = reclamos.find(
        (r) => r.id_reclamo === dataReclamo.id_reclamo,
      );
      if (actualizado) setDataReclamo(actualizado);
    }
  }, [reclamos]);

  const handleCloseFacturar = (value) => {
    setFacturar(false);
    getReclamos();
  };

  const renderTanquesChips = () => (
    <Box display="flex" gap={2} mt={1} flexWrap="wrap">
      <Chip
        label={`0.5m3: ${cantidadTanques?.cerocinco ?? 0}`}
        color="primary"
        variant="outlined"
      />
      <Chip
        label={`1m3: ${cantidadTanques?.uno ?? 0}`}
        color="primary"
        variant="outlined"
      />
      <Chip
        label={`2m3: ${cantidadTanques?.dos ?? 0}`}
        color="primary"
        variant="outlined"
      />
      <Chip
        label={`4m3: ${cantidadTanques?.cuatro ?? 0}`}
        color="primary"
        variant="outlined"
      />
      <Chip
        label={`7m3: ${cantidadTanques?.siete ?? 0}`}
        color="primary"
        variant="outlined"
      />
      <Chip
        label={`Otros: ${cantidadTanques?.otro ?? 0}`}
        color="primary"
        variant="outlined"
      />
    </Box>
  );

  const renderEstadosChips = () => (
    <Box display="flex" gap={2} flexWrap="wrap">
      {estadosConfig.map((estado) => {
        const isActive = estadoSeleccionado === estado.id;
        const count = cantidadReclamos?.[estado.key] ?? 0;

        return (
          <Chip
            key={estado.key}
            label={`${estado.label}: ${count}`}
            color={isActive ? estado.color : "default"}
            variant={isActive ? "filled" : "outlined"}
            clickable
            sx={{
              height: 38,
              borderRadius: "20px",
              fontWeight: isActive ? 600 : 400,
              transition: "0.2s",
              "&:hover": {
                transform: "translateY(-2px)",
              },
            }}
            onClick={() =>
              setEstadoSeleccionado((prev) =>
                prev === estado.id ? null : estado.id,
              )
            }
          />
        );
      })}
    </Box>
  );

  // console.log("cantidad reclamos", cantidadReclamos);

  return (
    <div>
      {tabla && reclamosFiltrados && (
        <Box mb={5}>
          <MaterialReactTable
            // data={reclamos}
            data={reclamosFiltrados}
            getRowId={(row) => row.id_reclamo}
            columns={filteredColumns}
            initialState={initialState}
            enableRowActions={localStorage.getItem("sector") !== "13"}
            // enableExpanding={false}
            enableColumnResizing
            enableFacetedValues
            enableFullScreenToggle={false}
            enableColumnFilters={false}
            // manualSorting={true}
            enableSorting
            state={{ pagination }}
            onPaginationChange={setPagination}
            // autoResetPageIndex={false}
            positionActionsColumn="last"
            // enableExpandAll={false}
            enableToolbarInternalActions
            muiTableHeadCellProps={tableHeadCellProps}
            muiTableBodyProps={({ row, column }) => {
              const value = row?.original?.[column.id];
              const isNumber = typeof value === "number" && !isNaN(value);
              return {
                align: isNumber ? "right" : "left",
                sx: {
                  backgroundColor: bgcolor[row?.original.estado] ?? "#fff",
                  color: "black",
                  borderColor: "black",
                },
              };
            }}
            enableColumnActions={false}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={false}
            layoutMode="semantic"
            positionGlobalFilter="right"
            localization={customLocalization}
            // enableColumnDragging={false}
            // enablePinning={false}
            enableHiding={false}
            displayColumnDefOptions={{
              "mrt-row-expand": {
                size: 10,
                align: "left", // ancho
                // minSize: 50,
                // maxSize: 50,
              },
            }}
            renderDetailPanel={({ row }) => (
              <Box sx={{ width: "100%" }}>
                <DetalleReclamo2
                  key={`${dataReclamo.id_reclamo}`}
                  datos={row.original}
                  activeTab={props.activeTab}
                  actualizar={getReclamos}
                  reclamos={reclamos}
                  sethayTanques={sethayTanques}
                  haytanques={haytanques}
                />
              </Box>
            )}
            // renderTopToolbarCustomActions={() => (
            //     <>
            //         {props.activeTab === 0 && (
            //             <Box display="flex" gap={2} mt={1} flexWrap="wrap">
            //                 <Chip label={`0.5m3: ${cantidadTanques?.cerocinco ?? 0}`} color="primary" variant="outlined" />
            //                 <Chip label={`1m3: ${cantidadTanques?.uno ?? 0}`} color="primary" variant="outlined" />
            //                 <Chip label={`2m3: ${cantidadTanques?.dos ?? 0}`} color="primary" variant="outlined" />
            //                 <Chip label={`4m3: ${cantidadTanques?.cuatro ?? 0}`} color="primary" variant="outlined" />
            //                 <Chip label={`7m3: ${cantidadTanques?.siete ?? 0}`} color="primary" variant="outlined" />
            //                 <Chip label={`Otros: ${cantidadTanques?.otro ?? 0}`} color="primary" variant="outlined" />
            //             </Box>
            //         )}

            //         {(props.activeTab === 1 || props.activeTab === 2) && (
            //             <Box display="flex" gap={2} mt={1} flexWrap="wrap">
            //                 {estadosConfig.map((estado) => (
            //                     <Chip
            //                         key={estado.key}
            //                         label={`${estado.label}: ${cantidadReclamos?.[estado.key] ?? 0}`}
            //                         color={estado.color}
            //                         variant={estadoSeleccionado === estado.id ? "filled" : "outlined"}
            //                         clickable
            //                         sx={{ fontSize: "1rem", padding: "8px 12px" }}
            //                         onClick={() =>
            //                             setEstadoSeleccionado((prev) =>
            //                                 prev === estado.id ? null : estado.id
            //                             )
            //                         }
            //                     />
            //                 ))}
            //             </Box>
            //         )}
            //     </>
            // )}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  mt: 1,
                }}
              >
                {props.activeTab === 0 && renderTanquesChips()}
                {/* CHIPS */}
                {
                  (props.activeTab === 1 || props.activeTab === 2) &&
                    renderEstadosChips()
                  // <Box
                  //     sx={{
                  //         display: "flex",
                  //         gap: 2,
                  //         flexWrap: "wrap",
                  //         backgroundColor: "#f5f7fa",
                  //         p: 2,
                  //         borderRadius: 2,
                  //     }}
                  // >
                  //     {estadosConfig.map((estado) => {
                  //         const isActive = estadoSeleccionado === estado.id;
                  //         const count = cantidadReclamos?.[estado.key] ?? 0;

                  //         return (
                  //             <Chip
                  //                 key={estado.key}
                  //                 label={`${estado.label}: ${count}`}
                  //                 color={isActive ? estado.color : "default"}
                  //                 variant={isActive ? "filled" : "outlined"}
                  //                 clickable
                  //                 onClick={() =>
                  //                     setEstadoSeleccionado((prev) =>
                  //                         prev === estado.id ? null : estado.id
                  //                     )
                  //                 }
                  //                 sx={{
                  //                     height: 38,
                  //                     borderRadius: "20px",
                  //                     fontWeight: isActive ? 600 : 400,
                  //                     transition: "0.2s",
                  //                     "&:hover": {
                  //                         transform: "translateY(-2px)",
                  //                     },
                  //                 }}
                  //             />
                  //         );
                  //     })}
                  // </Box>
                }
              </Box>
            )}
            renderRowActionMenuItems={({ row, closeMenu }) => [
              <MenuItem
                disabled={
                  row.original.estado === 347 ||
                  row.original.estado === 346 ||
                  row.original.estado === 342 ||
                  row.original.estado === 171 ||
                  row.original.estado === 348 ||
                  haytanques === false ||
                  (row.original.id_motivo === 19 && row.original.estado === 170)
                }
                key={0}
                onClick={() => {
                  setDataReclamo(row.original); //lleno los datos de la row
                  setconfirmarGrua(true);
                  closeMenu();
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <DoneOutline color="success" />
                </ListItemIcon>
                Confirmar Grúa
              </MenuItem>,
              <MenuItem
                disabled={row.original.estado !== 347}
                key={1}
                onClick={() => {
                  setDataReclamo(row.original); //lleno los datos de la row
                  setAsignar(true);
                  closeMenu();
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <Build color="action" />
                </ListItemIcon>
                Asignar Técnico
              </MenuItem>,
              <MenuItem
                disabled={row.original.estado !== 170}
                key={2}
                onClick={() => {
                  setDataReclamo(row.original); //lleno los datos de la row
                  setAsignar(true);
                  closeMenu();
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <Build color="action" />
                </ListItemIcon>
                Reasignar Técnico
              </MenuItem>,
              <MenuItem
                disabled={
                  row.original.estado !== 275 &&
                  row.original.estado !== 346 &&
                  row.original.estado !== 8
                }
                key={3}
                onClick={() => {
                  setDataReclamo(row.original);
                  setPendienteFinalizar(true);
                  closeMenu();
                }}
              >
                <PendingActionsIcon>
                  <Beenhere color="info" />
                </PendingActionsIcon>
                Pendiente de finalizar
              </MenuItem>,
              <MenuItem
                disabled={row.original.estado !== 342}
                key={3}
                onClick={() => {
                  setDataReclamo(row.original);
                  setFinalizar(true);
                  closeMenu();
                }}
              >
                <ListItemIcon>
                  <Beenhere color="success" />
                </ListItemIcon>
                Finalizar
              </MenuItem>,
              <MenuItem
                disabled={row.original.estado === 171}
                key={4}
                onClick={() => {
                  setDataReclamo(row.original);
                  setCancelar(true);
                  closeMenu();
                }}
              >
                <ListItemIcon>
                  <DoDisturbAlt color="error" />
                </ListItemIcon>
                Cancelar
              </MenuItem>,
              <Badge
                key={5}
                color="primary"
                badgeContent={row.original.total_archivos} // Muestra el número correcto de adjuntos
                showZero
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiBadge-badge": {
                    fontSize: "0.75rem", // Tamaño de fuente más pequeño
                    minWidth: "17px", // Ancho mínimo del badge
                    height: "17px", // Alto mínimo del badge
                    padding: "0 3px", // Padding ajustado para el contenido
                    transform: "translateX(32px)", // Desplaza el badge hacia la derecha
                  },
                }}
              >
                <MenuItem
                  // disabled={row.original.estado !== 275}
                  key={0}
                  onClick={() => {
                    // setNewUuid(row.original.uuid);
                    // setOpenCloseAdj(!openCloseAdj);
                    setDataReclamo(row.original); //lleno los datos de la row
                    setopenclose(true);
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <AttachFile color="action" />
                    {/* <DoneOutline color="success" /> */}
                  </ListItemIcon>
                  Adjuntos
                </MenuItem>
              </Badge>,
              <MenuItem
                disabled={
                  row.original.estado === 171 || row.original.estado === 223
                }
                key={6}
                onClick={() => {
                  setDataReclamo(row.original);
                  setEditar(true);
                  closeMenu();
                }}
              >
                <ListItemIcon>
                  <Edit color="action" />
                </ListItemIcon>
                Editar
              </MenuItem>,
              <MenuItem
                disabled={row.original.estado !== 171}
                key={8}
                onClick={() => {
                  setDataReclamo(row.original);
                  setFacturar(true);
                  closeMenu();
                }}
              >
                <ListItemIcon>
                  <Receipt color="secondary" />
                </ListItemIcon>
                Facturar
              </MenuItem>,
            ]}
          />
          {/* <p>{JSON.stringify(reclamos)}</p> */}
        </Box>
      )}

      {confirmarGrua && (
        <ConfirmarGrua
          datos={dataReclamo}
          open={confirmarGrua}
          setOpen={setconfirmarGrua}
          tabla={setTabla}
          actualizar={getReclamos}
        />
      )}
      {asignar && (
        <AsignarTecnico2
          datos={dataReclamo}
          open={asignar}
          setOpen={setAsignar}
          tabla={setTabla}
          actualizar={getReclamos}
        />
      )}
      {pendienteFinalizar && (
        <ModalPendienteDeFinalizacion
          showToast={showToast}
          datos={dataReclamo}
          open={pendienteFinalizar}
          onClose={() => setPendienteFinalizar(false)}
          tabla={setTabla}
          actualizar={getReclamos}
        />
      )}
      {finalizar && (
        <FinalizarReclamo
          key={`${dataReclamo.id_reclamo}_${dataReclamo.total_archivos}`}
          datos={dataReclamo}
          open={finalizar}
          setOpen={setFinalizar}
          tabla={setTabla}
          actualizar={getReclamos}
        />
      )}
      {facturar && (
        <Facturado
          datos={dataReclamo}
          open={facturar} // Pasa el estado booleano
          setOpen={setFacturar} // Pasa la función para actualizar el estado
          tabla={setTabla}
          actualizar={getReclamos}
          onClose={handleCloseFacturar}
        />
      )}
      {editar && (
        <EditarReclamoInst
          datos={dataReclamo}
          open={editar}
          setOpen={setEditar}
          actualizar={getReclamos}
        />
      )}

      {cancelar && (
        <CancelarReclamo2
          datos={dataReclamo}
          open={cancelar} // Pasa el estado booleano
          setOpen={setCancelar} // Pasa la función para actualizar el estado
          tabla={setTabla}
          actualizar={getReclamos}
        />
      )}

      {openclose && (
        <UpdatedUploadFiles
          fileId={dataReclamo.uuid}
          open={openclose}
          setOpen={setopenclose}
          title={"Adjuntos"}
        />
      )}
      {Toast}
    </div>
  );
}
{
  /* {props.activeTab === 1 && (
                                    <Box display="flex" gap={2} mt={1} flexWrap="wrap">
                                        <Chip
                                            label={`Abiertos: ${cantidadReclamos.abiertos ?? "0"}`}
                                            color="primary"
                                            variant="outlined"
                                            sx={{ fontSize: "1rem", padding: "8px 12px" }}
                                        />
                                        <Chip
                                            label={`Asignados: ${cantidadReclamos.asignados ?? "0"}`}
                                            color="secondary"
                                            variant="outlined"
                                            sx={{ fontSize: "1rem", padding: "8px 12px" }}
                                        />
                                        <Chip
                                            label={`Cancelados: ${cantidadReclamos.cancelados ?? "0"}`}
                                            color="error"
                                            variant="outlined"
                                            sx={{ fontSize: "1rem", padding: "8px 12px" }}
                                        />
                                        <Chip
                                            label={`Finalizados: ${cantidadReclamos.finalizados ?? "0"}`}
                                            sx={{
                                                backgroundColor: "#4caf50",
                                                color: "white",
                                                fontSize: "1rem",
                                                padding: "8px 12px"
                                            }}


                                        />
                                    </Box>
                                )}
                                {props.activeTab === 2 && (
                                    <Box display="flex" flexDirection="column" gap={2} alignItems="center">
                                        <Typography variant="poster" fontSize={20}>
                                            {(() => {
                                                const data = cantidadReclamos;

                                                return (
                                                    <>
                                                        <span style={{ marginRight: 20 }}>Abiertos: {data.abiertos ?? "0"}</span>
                                                        <span style={{ marginRight: 20 }}>Asignados: {data.asignados ?? "0"}</span>
                                                        <span style={{ marginRight: 20 }}>Cancelados: {data.cancelados ?? "0"}</span>
                                                        <span>Finalizados: {data.finalizados ?? "0"}</span>
                                                    </>
                                                );
                                            })()}
                                        </Typography>

                                        {/* Chips de tanques 
{
    sector === "12" ?
    <Box display="flex" gap={1} flexWrap="wrap">
        {Array.isArray(cantidadTanques) &&
            cantidadTanques.map(({ capacidad, cantidad }, index) => (
                <Chip
                    key={index}
                    label={`${capacidad}m3: ${cantidad}`}
                    size="small"
                    sx={{
                        fontSize: "0.85rem",
                        bgcolor: "#5c8ba8ff",
                        color: "white",
                    }}
                />
            ))}
    </Box>
    : null
}
                                    </Box >
                                )} */
} //me falta filtrar si soy comercial o no

// const getReclamos = () => {
//     const isSector12 = sector === "12";
//     const prefix = isSector12 ? "/reclamos/all" : "/reclamos/all_comercial";
//     const user = localStorage.getItem("user");

//     let categorias = "";
//     let estados = "";

//     if (props.activeTab === 0) {
//         categorias = categoriasGrua.join(",");
//         estados = ["275", "348"];
//     } else if (props.activeTab === 1) {
//         categorias = categoriasInstalaciones.join(",");
//         estados = estadoReclamosInstalaciones.join(",");

//     } else {
//         categorias = categoriasReemplazos.join(",");
//         estados = estadoReclamosReemplazos.join(",");
//     }

//     const url = isSector12
//         ? `${prefix}/${categorias}/${estados}`
//         : `${prefix}/${categorias}/${estados}/${user}`;

//     getData(url, setReclamos);

//     if (props.activeTab === 0) {
//         if (isSector12) {
//             getData('/reclamos/cantTanquesGrua', setcantidadTanques)
//             // console.log("cant", cantidadTanques);
//         } else {
//             getData(`/reclamos/comercial_cantTanquesGrua/${user}`, setcantidadTanques);
//             // console.log("cant", cantidadTanques);

//         }
//     }

//     if (props.activeTab === 1) {
//         if (isSector12) {
//             getData(`/reclamos/allr/cantidad_reclamos/281`, setcantidadReclamos);
//             // console.log("cantidad reclamos", cantidadReclamos);

//         } else {
//             getData(`/reclamos/cantidadReclamosComercial/${user}/281`, setcantidadReclamos);
//             // console.log("cantidad reclamos", cantidadReclamos);

//         }
//     }

//     if (props.activeTab === 2) {
//         if (isSector12) {
//             getData(`/reclamos/cantidadTanqueReemplazo`, setcantidadTanques)

//             getData(`/reclamos/allr/cantidad_reclamos/321`, setcantidadReclamos)

//         } else {
//             getData(`/reclamos/cantidadReclamosComercial/${user}/321`, setcantidadReclamos)
//         }
//     }
// };
